import { render, staticRenderFns } from "./multigroup.vue?vue&type=template&id=7ffe28b4"
import script from "./multigroup.vue?vue&type=script&lang=js"
export * from "./multigroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ffe28b4')) {
      api.createRecord('7ffe28b4', component.options)
    } else {
      api.reload('7ffe28b4', component.options)
    }
    module.hot.accept("./multigroup.vue?vue&type=template&id=7ffe28b4", function () {
      api.rerender('7ffe28b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/multigroup.vue"
export default component.exports